export default __webpack_public_path__ + "static/media/Scope-6.e648165c.png";